


































































import { Component, Vue } from "vue-property-decorator";

import EntityCrud from "../layouts/components/EntityCrud.vue";
import psychologistsModel from "../models/user.model";
import companyModel from "@/models/company.model";

@Component({
  components: { EntityCrud },
})
export default class Psychologists extends Vue {
  customDetails: any = (data: any) => { this.showCompanies(data) } //this.showCompanies;
  customDetailsTitle: string = "Empresas";
  activePrompt: boolean = false;
  activePromptDelete: boolean = false;
  newCompany: any = null;
  userId: number;
  companySpecialityId: number;

  companies: any[] = [];
  specialists: any[] = [];

  //validCompany: boolean = true;

  model: any = psychologistsModel;
  companyModel: any = companyModel;

  title = "Profissionais";
  tableColumns = ["email", "name"];
  filter = { role: "PSYCHOLOGIST" };

  formColumns = ["email", "name", "password", "crp", "birthDate", "gender", "phoneNumber", "about", "educationalBackground", "fiqueOk", "teams", "whatsapp"];
  defaultEntity = { role: "PSYCHOLOGIST", userType: "CLIENT" };

  async mounted() {
    this.companies = await companyModel.search({});
    //this.specialists = await psychologistsModel.
  }

  async getSpecialists(user: any) {
    const result = await psychologistsModel.getCompanies(user);
    //console.log('getSpecialists', this.specialists);
    setTimeout(() => {
      this.specialists = result;
    }, 200);
  }

  async showCompanies(data: any) {
    console.log(data);
    this.userId = data.id;

    this.activePrompt = true;
    this.getSpecialists({ id: data.id })

  }

  async addCompany() {
    this.confirmDeleteCompany(0, false);
    //console.log('valid ', this.newCompany);    
    if (this.newCompany) {
      //verificar se existe
      const exists = this.specialists.find(e => e.company.id === this.newCompany.id);
      if (exists) {
        this.$vs.notify({ title: "Erro", text: "Empresa já cadastrada.", iconPack: "feather", icon: "icon-alert-circle", color: "danger" });
        return;
      }
      //console.log('valid ', this.newCompany);    
      try {
        await psychologistsModel.addCompany(this.userId, this.newCompany.id);
        this.getSpecialists({ id: this.userId });
      } catch (e) {
        console.log('error', e);
        this.$vs.notify({ title: "Erro", text: "Ocorreu um erro. Tente novamente.", iconPack: "feather", icon: "icon-alert-circle", color: "danger" });
      }
    }
  }

  //adicionar todas as empresas ativas
  async addCompanies() {
    this.confirmDeleteCompany(0, false);
    //console.log('valid ', this.newCompany);    
    //console.log('valid ', this.newCompany);    
    try {
      const result = await psychologistsModel.addCompanies(this.userId);
      console.log('addCompanies', result);
      this.getSpecialists({ id: this.userId });
    } catch (e) {
      console.log('error', e);
      this.$vs.notify({ title: "Erro", text: "Ocorreu um erro. Tente novamente.", iconPack: "feather", icon: "icon-alert-circle", color: "danger" });
    }

  }

  confirmDeleteCompany(id: any, confirmed: boolean = true) {
    console.log(id);
    this.activePromptDelete = false;

    this.activePromptDelete = confirmed;
    if (confirmed) {
      this.companySpecialityId = id;
    } else {
      this.companySpecialityId = 0;
    }
  }

  async deleteCompany() {
    this.$vs.loading();
    try {
      await psychologistsModel.deleteCompany(this.companySpecialityId);
      this.$vs.notify({ title: "Sucesso", text: "O registro foi excluído.", iconPack: "feather", icon: "icon-check", color: "success" });
      this.confirmDeleteCompany(0, false);
      this.getSpecialists({ id: this.userId });
      //this.$router.back();
    } catch (error) {
      //console.error(error);
      this.$vs.notify({ title: "Erro", text: "Ocorreu um erro. Tente novamente.", iconPack: "feather", icon: "icon-alert-circle", color: "danger" });
      this.confirmDeleteCompany(0, false);
    }
    this.$vs.loading.close();
  }

}
